<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (showSliderHeader) {
<header class="slider-title">
  @if (slice.settings.general.showSliderTitle && slice.settings.general.sliderTitle?.length > 0) {
  <render-wysiwyg
    [html]="slice.settings.general.sliderTitle"
    [textPaddingTop]="slice.settings.general.sliderTitlePadding?.textPaddingTop"
    [textPaddingBottom]="slice.settings.general.sliderTitlePadding?.textPaddingBottom"
    [textPaddingLeft]="slice.settings.general.sliderTitlePadding?.textPaddingLeft"
    [textPaddingRight]="slice.settings.general.sliderTitlePadding?.textPaddingRight">
  </render-wysiwyg>
  }

  @if (arrowPosition === 'header-right') {
    <ng-container *ngTemplateOutlet="sliderArrows"></ng-container>
  }

</header>
}

<div
  class="slice-slider-wrapper"
  #sliceSliderWrapper
  [ngClass]="fxSlide"
  [class.scaleInit]="slice.settings.general.transitionType === 'cube'"
  [class.scaleTransition]="slice.settings.general.transitionType === 'cube' && isScale"
  [class.mobile]="isMobile"
  (touchstart)="showNavigationControls()">

  @if (slidesRange.length > 0) {
  <div
    #swiper
    cmsSwiper
    class="swiper-container"
    [class.swiper-container-vertical]="swiperConfig.direction === 'vertical'"
    [config]="swiperConfig">
    <div class="swiper-wrapper">
      @for (copy of (slice.settings.general.loop && slice.settings.general.transitionType === 'creative') ? [0, 1, 2] : [0]; track copy) {
        @for (slide of slidesRange; track slide) {
          <div class="swiper-slide">
          <div
            [ngStyle]="{
              'margin-left': initialOffset(slide),
              'margin-right': lastOffset(slide)
            }">
            <render-slice-slot
              data-e2e="render-slice-slot"
              [slice]="slice"
              [slot]="(slide + 1).toString()"
              [ngStyle]="getSlotStyles(slots[slide])">
            </render-slice-slot>
          </div>
          </div>
        }
      }
    </div>
    <div
      slot="container-end"
      class="hidden">
      <ng-container *ngTemplateOutlet="slideDescriptionTemplate"></ng-container>
    </div>
    <div class="swiper-pagination"></div>
  </div>
  }

  @if (arrowPosition === 'inside-left-right' || arrowPosition === 'bottom-right') {
    <ng-container *ngTemplateOutlet="sliderArrows"></ng-container>
  }

  @if (slice?.settings.general.pagination && this.isPagerStylecount) {
  <div class="swiper-pagination-count">
    <button
      class="button-prev"
      (click)="arrowClick('prev')">
      <svg
        viewBox="0 0 11 16"
        fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.82242 8L10.6154 14.532L9.08879 16L0.769231 8L9.08879 -8.65753e-07L10.6154 1.46796L3.82242 8Z" />
      </svg>
    </button>
    <div class="slides-count">
      <span>{{ currentIndex + 1 }}</span>
      <span>|</span>
      <span>{{ slidesRange.length }}</span>
    </div>
    <button
      class="button-next"
      (click)="arrowClick('next')">
      <svg
        viewBox="0 0 11 16">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.79296 8L0 1.46796L1.5266 0L9.84615 8L1.5266 16L0 14.532L6.79296 8Z" />
      </svg>
    </button>
    <ng-container *ngTemplateOutlet="slideDescriptionTemplate"></ng-container>
  </div>
  }
</div>

<ng-template #sliderArrows>
  @if(shouldShowAccessibilityControls) {
    @if ((arrowIsIcon || arrowIsCustomIcon || arrowIsTitle) && isScrollPager) {
      <div
        class="arrow-control"
        [ngClass]="{
          'arrow-control-mm-vertical': swiperDirectionVer,
          'arrow-control-mm-horizontal': swiperDirectionHor,
          'arrow-position-bottom-right': arrowPosition === 'bottom-right'
        }">
      <div
        class="swiper-controls-container">
        <div
          role="button"
          tabindex="0"
          attr.aria-label="Anterior"
          (click)="arrowClick('prev')"
          class="swiper-arrow swiper-arrow-prev">
            @if (arrowIsIcon) {
            <svg
              viewBox="0 0 32 33"
              fill="none">
              <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.5136 10.283C19.7088 10.4783 19.7088 10.7949 19.5136 10.9902L13.7071 16.7966L19.5136 22.6031C19.7088 22.7983 19.7088 23.1149 19.5136 23.3102C19.3183 23.5054 19.0017 23.5054 18.8065 23.3102L12.6464 17.1502C12.4512 16.9549 12.4512 16.6383 12.6464 16.443L18.8065 10.283C19.0017 10.0878 19.3183 10.0878 19.5136 10.283Z"
              fill="black"/>
            </svg>
            }

            @if (arrowIsCustomIcon) {
            <img
              alt="Anterior"
              aria-hidden="true"
              [src]="getArrowIcon('prev')"/>
            }
            @if (arrowIsTitle) {
            <render-wysiwyg
              class="swiper-page-title"
              [html]="getArrowText('prev')">
            </render-wysiwyg>
            }
        </div>
        <div
          class="slice-slider-control"
          role="button"
          tabindex="0"
          [attr.aria-label]="getAutoplayControlButtonAriaLabel()"
          [ngClass]="'slice-slider-control-'+slice?.settings.general.accessibility?.controlButtonPosition"
          (click)="controlAutoplayClick()">
          @if (slice?.settings.general.autoplay && slice?.settings.general.accessibility?.isControlButtonEnabled) {
          @if (swiperContainer?.nativeElement?.swiper?.autoplay; as autoplay) {
            @if (autoplay.running) {
            <svg
              height="18"
              viewBox="0 0 12 18"
              fill="none">
                <rect
                  x="1"
                  y="1.31006"
                  height="15.3798"
                  rx="1.5"
                  stroke="black"
                  stroke-linejoin="round"/>
                <rect
                  x="8"
                  y="1.31006"
                  height="15.3798"
                  rx="1.5"
                  stroke="black"
                  stroke-linejoin="round"/>
            </svg>
            }
            @if (!autoplay.running) {
            <svg
              height="16"
              viewBox="0 0 15 16"
              fill="none">
                <path
                  d="M14 7.53406C14.3331 7.72654 14.3331 8.20681 14 8.39929L2 15.328C1.66667 15.5204 1.25 15.2793 1.25 14.8944L1.25 1.03894C1.25 0.678172 1.61614 0.443542 1.93652 0.574096L2 0.605346L14 7.53406Z"
                  stroke="black"/>
            </svg>
            }
          }
          }
        </div>
        <div
          role="button"
          tabindex="0"
          attr.aria-label="Siguiente"
          (click)="arrowClick('next')"
          class="swiper-arrow swiper-arrow-next">
          @if (arrowIsIcon) {
          <svg
            viewBox="0 0 32 33"
            fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.6464 10.283C12.8417 10.0878 13.1583 10.0878 13.3536 10.283L19.5136 16.443C19.7088 16.6383 19.7088 16.9549 19.5136 17.1502L13.3536 23.3102C13.1583 23.5054 12.8417 23.5054 12.6464 23.3102C12.4512 23.1149 12.4512 22.7983 12.6464 22.6031L18.4529 16.7966L12.6464 10.9902C12.4512 10.7949 12.4512 10.4783 12.6464 10.283Z"
              fill="black"/>
          </svg>
          }

          @if (arrowIsCustomIcon) {
          <img
            alt="Siguiente"
            aria-hidden="true"
            [src]="getArrowIcon('next')">
          }
          @if (arrowIsTitle) {
          <render-wysiwyg
            class="swiper-page-title"
            [html]="getArrowText('next')">
          </render-wysiwyg>
          }
        </div>
      </div>
    </div>
    }
  }
</ng-template>

<ng-template #slideDescriptionTemplate>
  <render-wysiwyg
    class="slide-description"
    [html]="slideDescription">
  </render-wysiwyg>
</ng-template>
